export const confidenceColors = [{
  title: 'more than 91%',
  color: '#FFFFFF',
}, {
  title: '81-90%',
  color: '#F3CCCB',
}, {
  title: '70-80%',
  color: '#E99798',
}, {
  title: 'less than 70%',
  color: '#D56465',
}];
